module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_01_6NV26_1SA_H2G.708bc887.jpg";